"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.trimText = exports.replaceEmptyPTags = exports.renderScenario = exports.renderQuestionComment = exports.renderQuestion = exports.renderKnockout = exports.renderHint = exports.removeOptionIds = exports.removeHtmlTags = exports.limitText = exports.getSelectedIds = exports.getDefaultQuestionSettings = exports.defaultFunction = exports.decodeText = exports.assignOptionIds = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.find.js");
var _react = _interopRequireDefault(require("react"));
var _callout = require("@citrus/callout");
var _html = require("@citrus/html");
var _inputWysiwyg = require("@citrus/input-wysiwyg");
var _tag = require("@citrus/tag");
var _inputCheckbox = require("@citrus/input-checkbox");
var _inputTextfield = require("@citrus/input-textfield");
var _inputTextarea = require("@citrus/input-textarea");
var _questionBuilder = require("@pcty/question-builder");
var _isNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNullOrEmpty"));
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _get = _interopRequireDefault(require("@pcty/utils-commonjs/object/get"));
var _uuid = _interopRequireDefault(require("uuid"));
var _lodash = _interopRequireDefault(require("lodash.uniq"));
var _lodash2 = _interopRequireDefault(require("lodash.findindex"));
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Constants");
var he = _interopRequireWildcard(require("he"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var decodeText = exports.decodeText = function decodeText(text) {
  var fixedText = text;
  if (text) {
    fixedText = he.decode(text);
    fixedText = fixedText.replace(/“|”/g, '"');
    fixedText = fixedText.replace(/‘|’/g, "'");
  }
  return fixedText;
};
var limitText = exports.limitText = function limitText() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var addEllipses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var text = string.substring(0, limit);
  return text.length < string.length && addEllipses ? "".concat(text, "...") : text;
};
var trimText = exports.trimText = function trimText(text) {
  return text && typeof text === 'string' ? text.trim() : text;
};
var defaultFunction = exports.defaultFunction = function defaultFunction() {};
var getSelectedIds = exports.getSelectedIds = function getSelectedIds(options) {
  var output = [];
  for (var i = 0; i < options.length; i++) {
    if (options[i].selected) {
      output = [].concat((0, _toConsumableArray2.default)(output), [{
        optionId: options[i].id
      }]);
    }
  }
  return output;
};
var removeOptionIds = exports.removeOptionIds = function removeOptionIds(edit) {
  if (!edit) return null;
  var options = edit.options.map(function (x) {
    return {
      id: x.id,
      value: x.value
    };
  });
  return _objectSpread(_objectSpread({}, edit), {}, {
    options: options
  });
};
var assignOptionIds = exports.assignOptionIds = function assignOptionIds(edit) {
  if (!edit) return null;

  //TODO: why don't we do this for dropdowns, multitext, constantsum, stackrank, etc??

  var options = edit.options.map(function (x) {
    switch (edit.typeId) {
      case _questionBuilder.QUESTION_TYPE.multipleChoice:
      case _questionBuilder.QUESTION_TYPE.trueFalse:
        return _objectSpread(_objectSpread({}, x), {}, {
          selected: edit.answers && edit.answers.length > 0 && x.id === edit.answers[0].optionId
        });
      case _questionBuilder.QUESTION_TYPE.checkbox:
        return _objectSpread(_objectSpread({}, x), {}, {
          selected: edit.answers && edit.answers.length > 0 && (0, _lodash2.default)(edit.answers, function (z) {
            return z.optionId === x.id;
          }) >= 0
        });
      default:
        return x;
    }
  });
  return _objectSpread(_objectSpread({}, edit), {}, {
    options: options
  });
};
var getDefaultFormValidationState = function getDefaultFormValidationState() {
  return {
    valid: true,
    showValidationState: false,
    question: getDefaultValidationState(),
    answer: getDefaultValidationState(),
    otherOption: getDefaultValidationState(),
    targetSum: getDefaultValidationState(),
    minMax: getDefaultValidationState()
  };
};
var getDefaultValidationState = function getDefaultValidationState() {
  return {
    valid: true,
    errorMessage: ''
  };
};
var validate = exports.validate = function validate(edit, showValidationState, builderType) {
  var questionTextOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var validationState = _objectSpread(_objectSpread({}, getDefaultFormValidationState()), {}, {
    showValidationState: showValidationState
  });
  if (!edit || edit.typeId === _questionBuilder.QUESTION_TYPE.title || edit.typeId === _questionBuilder.QUESTION_TYPE.video) {
    return validationState;
  }
  if (edit.typeId === _questionBuilder.QUESTION_TYPE.paragraph) {
    if (edit.content && edit.content.length) return validationState;
    return _objectSpread(_objectSpread({}, validationState), {}, {
      valid: false,
      answer: {
        valid: false,
        errorMessage: 'Text is required'
      }
    });
  }
  var questionText = removeHtmlTags(edit.question);
  if (questionText.length <= 0) {
    validationState = _objectSpread(_objectSpread({}, validationState), {}, {
      valid: false,
      question: {
        valid: false,
        errorMessage: 'The Question field is required.'
      }
    });
  }

  // leave early if we're only doing text!
  if (questionTextOnly) return validationState;
  if (edit.typeId === _questionBuilder.QUESTION_TYPE.constantSum) {
    if (edit.minimumValue && edit.maximumValue && parseInt(edit.minimumValue) >= parseInt(edit.maximumValue)) {
      validationState = _objectSpread(_objectSpread({}, validationState), {}, {
        valid: false,
        minMax: {
          valid: false,
          errorMessage: 'Maximum value must be greater than minimum value'
        }
      });
    } else if (edit.enforceTargetSum && !edit.targetSumValue || parseInt(edit.targetSumValue) <= 0) {
      validationState = _objectSpread(_objectSpread({}, validationState), {}, {
        valid: false,
        targetSum: {
          valid: false,
          errorMessage: 'Target Sum value must is required and must be greater than zero'
        }
      });
    } else if (edit.enforceTargetSum && edit.targetSumValue && edit.maximumValue && parseInt(edit.targetSumValue) < parseInt(edit.maximumValue)) {
      validationState = _objectSpread(_objectSpread({}, validationState), {}, {
        valid: false,
        targetSum: {
          valid: false,
          errorMessage: 'Target Sum value must be greater than maximum value'
        }
      });
    }
  }
  var hasOptions = [_questionBuilder.QUESTION_TYPE.multipleChoice, _questionBuilder.QUESTION_TYPE.multipleText, _questionBuilder.QUESTION_TYPE.dropdownList, _questionBuilder.QUESTION_TYPE.constantSum, _questionBuilder.QUESTION_TYPE.checkbox, _questionBuilder.QUESTION_TYPE.stackRank, _questionBuilder.QUESTION_TYPE.ratingScale].indexOf(edit.typeId) >= 0;
  if (hasOptions && edit.options && edit.typeId != _questionBuilder.QUESTION_TYPE.multipleChoice && edit.typeId != _questionBuilder.QUESTION_TYPE.checkbox && edit.options.length < 2) {
    validationState = _objectSpread(_objectSpread({}, validationState), {}, {
      valid: false,
      answer: {
        valid: false,
        errorMessage: 'You must have at least two options.'
      }
    });
  } else if (hasOptions && edit.options && (
  // Multiple Choice allows for single option if it also has 'other' option enabled.
  edit.typeId == _questionBuilder.QUESTION_TYPE.multipleChoice || edit.typeId == _questionBuilder.QUESTION_TYPE.checkbox) && (edit.otherQuestion && edit.otherQuestion.enabled && edit.options.length < 1 || edit.otherQuestion && !edit.otherQuestion.enabled && edit.options.length < 2)) {
    validationState = _objectSpread(_objectSpread({}, validationState), {}, {
      valid: false,
      answer: {
        valid: false,
        errorMessage: 'You must have at least two options.'
      }
    });
  } else if (builderType === _PctyQuestionBuilder.BUILDER_TYPE.quiz && edit.typeId !== _questionBuilder.QUESTION_TYPE.checkbox && edit.typeId !== _questionBuilder.QUESTION_TYPE.stackRank && edit.answers && edit.answers.length <= 0) {
    validationState = _objectSpread(_objectSpread({}, validationState), {}, {
      valid: false,
      answer: {
        valid: false,
        errorMessage: 'You must select a correct answer.'
      }
    });
  } else if (hasOptions && edit.options && edit.options.some(function (x) {
    return (0, _isNullOrEmpty.default)(x) || (0, _typeof2.default)(x) === 'object' && (0, _get.default)(x, 'value', '').length <= 0;
  })) {
    validationState = _objectSpread(_objectSpread({}, validationState), {}, {
      valid: false,
      answer: {
        valid: false,
        errorMessage: 'You cannot have an option with an empty value.'
      }
    });
  } else if (hasOptions && edit.options && (0, _lodash.default)(edit.options.map(function (x) {
    return x.value;
  })).length < edit.options.length) {
    validationState = _objectSpread(_objectSpread({}, validationState), {}, {
      valid: false,
      answer: {
        valid: false,
        errorMessage: 'You cannot have duplicate options.'
      }
    });
  } else if (hasOptions && edit.options && edit.otherQuestion && edit.otherQuestion.enabled && (0, _isNullOrEmpty.default)(trimText(edit.otherQuestion.label))) {
    validationState = _objectSpread(_objectSpread({}, validationState), {}, {
      valid: false,
      otherOption: {
        valid: false,
        errorMessage: 'You cannot have an empty Other Response Label.'
      }
    });
  }
  return validationState;
};
var renderScenario = exports.renderScenario = function renderScenario(id, scenario) {
  if ((0, _isNullOrEmpty.default)(scenario)) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-none"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12 pcty-padding-left"
  }, /*#__PURE__*/_react.default.createElement(_html.Html, {
    content: scenario,
    id: id + '-scenario',
    type: "html"
  })));
};
var removeHtmlTags = exports.removeHtmlTags = function removeHtmlTags(question) {
  return (0, _isNotNullOrEmpty.default)(question) ? question.replace(/<\/?[^>]+>/gi, '') : '';
};
var replaceEmptyPTags = exports.replaceEmptyPTags = function replaceEmptyPTags(content) {
  return content ? content.replace(/<p><\/p>/gi, '<br/>') : content;
};
var renderKnockout = exports.renderKnockout = function renderKnockout(id, knockout, knockoutText) {
  return knockout ? /*#__PURE__*/_react.default.createElement(_tag.Tag, {
    value: knockoutText
  }) : null;
};
var renderHint = exports.renderHint = function renderHint(id, hint) {
  if ((0, _isNullOrEmpty.default)(hint)) return null;
  return /*#__PURE__*/_react.default.createElement(_callout.Callout, {
    automationId: 'information-inset-banner-hint-' + id,
    id: 'information-inset-banner-hint-' + id
  }, /*#__PURE__*/_react.default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, hint));
};
var renderQuestion = exports.renderQuestion = function renderQuestion(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated) {
  if (editable) {
    var prefix = "".concat(required ? '*' : '', " ").concat(number, ". ");
    var edit = {
      question: question,
      typeId: questionTypeId
    };
    var validationState = validate(edit, true, _PctyQuestionBuilder.BUILDER_TYPE.survey, true);
    var _onChange = function onChange(rawContent) {
      var updatedQuestion = (0, _inputWysiwyg.toHtml)(rawContent);
      if (onQuestionTextUpdated) onQuestionTextUpdated(updatedQuestion);
    };
    var questionTypeInfo = _PctyQuestionBuilder.QUESTION_TYPES_LIST.find(function (x) {
      return x.questionTypeId === questionTypeId;
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
      className: "pcty-input-label question-display-label"
    }, prefix, " ", questionTypeInfo.label, " Question"), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: '10px',
        marginBottom: '10px'
      }
    }, /*#__PURE__*/_react.default.createElement(_inputWysiwyg.Wysiwyg, {
      id: id + '-question-content-wysiwyg',
      key: id + '-question-content-wysiwyg-key',
      onChange: function onChange(rc) {
        return _onChange(rc);
      },
      placeholder: "Please enter your text",
      errorMessage: validationState.question.errorMessage,
      showValidationState: validationState.showValidationState,
      valid: validationState.question.valid,
      rawContentState: !!question ? (0, _inputWysiwyg.fromHtml)(question) : null,
      toolbar: ['bold', 'italic', 'underline', 'unordered-list', 'ordered-list', 'undo', 'redo']
    })));
  } else {
    if ((0, _isNullOrEmpty.default)(question)) return null;
    var spliceString = function spliceString(sourceString, startIndex, insertString) {
      return sourceString.substring(0, startIndex) + insertString + sourceString.substring(startIndex);
    };
    var _prefix = "".concat(required ? '*' : '', " ").concat(number, ". ");
    var questionText = question.indexOf('<p>') === 0 ? spliceString(question, 3, _prefix) : _prefix + question;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "pcty-input-label question-display-label"
    }, /*#__PURE__*/_react.default.createElement(_html.Html, {
      className: "question-display-label",
      content: replaceEmptyPTags(questionText),
      id: id + '-question-content',
      htmlWrapperType: "span",
      type: "html"
    }));
  }
};
var renderQuestionComment = exports.renderQuestionComment = function renderQuestionComment(id, allowComments, textFieldValue, editable, questionCommentsEnabled, onCommentChange) {
  if (!questionCommentsEnabled) return null;
  var onChangeAllowCommentsCheckbox = function onChangeAllowCommentsCheckbox(e) {
    if (onCommentChange) onCommentChange({
      allowComments: e.selected
    });
  };
  var onChangeCommentsPlaceholder = function onChangeCommentsPlaceholder(e) {
    if (onCommentChange) onCommentChange({
      commentsPlaceholder: e.value
    });
  };
  if (editable) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-row pcty-padding-bottom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-col-xs-12"
    }, /*#__PURE__*/_react.default.createElement(_inputCheckbox.Checkbox, {
      automationId: "".concat(id, "-allow-comments"),
      id: "".concat(id, "-allow-comments"),
      onChange: onChangeAllowCommentsCheckbox,
      selected: allowComments
    }, "Allow Comments"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-row pcty-padding-bottom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-col-xs-10"
    }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
      disabled: !allowComments,
      id: "".concat(id, "-comment-placeholder"),
      label: "Placeholder Text",
      placeholder: 'Enter text',
      maxLength: 500,
      onChange: onChangeCommentsPlaceholder,
      value: textFieldValue
    }))));
  }
  return allowComments && /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_inputTextarea.Textarea, {
    id: "".concat(id, "-comment-textarea"),
    maxLength: 2000,
    onChange: function onChange(id, txt) {
      return console.log(txt);
    },
    label: "Comments",
    placeholder: textFieldValue,
    value: ''
  })));
};
var getDefaultQuestionSettings = exports.getDefaultQuestionSettings = function getDefaultQuestionSettings(typeId, required, pageId) {
  var key = _uuid.default.v4();
  var defaultQuestionKeys = {
    id: key,
    key: key,
    typeId: typeId,
    pageId: pageId,
    scenario: null,
    question: '',
    answerRequired: required,
    options: [{
      id: _uuid.default.v4(),
      value: 'Item 1'
    }, {
      id: _uuid.default.v4(),
      value: 'Item 2'
    }],
    answers: [],
    knockout: false,
    hint: '',
    correctFeedback: '',
    incorrectFeedback: '',
    showValidationState: false,
    commentsPlaceholder: 'Enter comment'
  };

  // keeping each queston type in seperate cases in case we need seperate options for each in the future
  switch (typeId) {
    default:
      return null;
    case _questionBuilder.QUESTION_TYPE.checkbox:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        displayFormat: 1
      });
    case _questionBuilder.QUESTION_TYPE.multipleChoice:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        otherQuestion: {
          id: _uuid.default.v4(),
          label: 'Other (describe)',
          enabled: false
        },
        displayOrder: {
          value: 'defined',
          label: 'As Defined'
        },
        displayFormat: 1
      });
    case _questionBuilder.QUESTION_TYPE.dropdownList:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        otherQuestion: {
          id: _uuid.default.v4(),
          label: 'Other (describe)',
          enabled: false
        },
        displayOrder: {
          value: 'defined',
          label: 'As Defined'
        },
        displayFormat: 1,
        questionPlaceholder: 'Select...'
      });
    case _questionBuilder.QUESTION_TYPE.trueFalse:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        options: [{
          id: _uuid.default.v4(),
          value: 'True'
        }, {
          id: _uuid.default.v4(),
          value: 'False'
        }]
      });
    case _questionBuilder.QUESTION_TYPE.stackRank:
      var stackRankOptions = [{
        id: _uuid.default.v4(),
        value: 'Item 1'
      }, {
        id: _uuid.default.v4(),
        value: 'Item 2'
      }];
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        options: stackRankOptions,
        answers: stackRankOptions.map(function (x) {
          return {
            optionId: x.id
          };
        })
      });
    case _questionBuilder.QUESTION_TYPE.title:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        options: [],
        title: '',
        includeSectionHeading: true
      });
    case _questionBuilder.QUESTION_TYPE.paragraph:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        options: [],
        content: '',
        placeHolderText: 'Placeholder Text for paragraph'
      });
    case _questionBuilder.QUESTION_TYPE.video:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        title: '',
        videoId: undefined,
        token: undefined,
        filename: undefined
      });
    case _questionBuilder.QUESTION_TYPE.textField:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        options: [],
        multiLine: false,
        questionPlaceholder: 'Enter text'
      });
    case _questionBuilder.QUESTION_TYPE.starRating:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        starCount: 5,
        value: undefined
      });
    case _questionBuilder.QUESTION_TYPE.ratingScale:
      var ratingScaleOptions = [{
        id: _uuid.default.v4(),
        value: 'Strongly Disagree'
      }, {
        id: _uuid.default.v4(),
        value: 'Disagree'
      }, {
        id: _uuid.default.v4(),
        value: 'Neutral'
      }, {
        id: _uuid.default.v4(),
        value: 'Agree'
      }, {
        id: _uuid.default.v4(),
        value: 'Strongly Agree'
      }];
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        options: ratingScaleOptions,
        minimumRateLabel: 'Lowest',
        maximumRateLabel: 'Highest',
        value: undefined
      });
    case _questionBuilder.QUESTION_TYPE.multipleText:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        displayOrder: {
          value: 'defined',
          label: 'As Defined'
        }
      });
    case _questionBuilder.QUESTION_TYPE.constantSum:
      return _objectSpread(_objectSpread({}, defaultQuestionKeys), {}, {
        enforceTargetSum: false,
        targetSumValue: 100,
        maximumValue: undefined,
        minimumValue: undefined
      });
  }
};